export default __webpack_public_path__ + "static/media/claim-time.ba3408cf.png";